exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-header {\r\n    font-size: 1.5em;\r\n    /*line-height: 0.75em;*/\r\n    vertical-align: -20%;\r\n  }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/header/header.component.css
// module id = ../../../../../src/app/header/header.component.css
// module chunks = main